/**
 * Lucide icon names for the rich text editor icon picker.
 * İlk sıra öncelikli ikonlar; sonra arama ile tüm ikonlar listelenir.
 */
import type React from 'react';
import * as LucideIcons from 'lucide-react';

export const PRIORITIZED_ICON_NAMES: string[] = [
  'Star',
  'Heart',
  'Check',
  'AlertCircle',
  'Info',
  'Camera',
  'Image',
  'Mail',
  'Phone',
  'MapPin',
  'Calendar',
  'FileText',
  'Download',
  'Upload',
  'Search',
  'Settings',
  'User',
  'Home',
  'Globe',
  'Zap',
];

const RESERVED = new Set(['default', 'createLucideIcon', 'LucideProps', 'Icon', 'icons']);
export const ALL_ICON_NAMES: string[] = Object.keys(LucideIcons).filter(
  (k) =>
    !RESERVED.has(k) &&
    !k.endsWith('Icon') &&
    k.length > 0 &&
    k[0] === k[0].toUpperCase()
);

export function getIconComponent(name: string): React.ComponentType<{ size?: number; className?: string }> | null {
  const C = (LucideIcons as Record<string, unknown>)[name];
  if (!C) return null;
  const Comp = typeof C === 'object' && C && (C as { default?: unknown }).default != null
    ? (C as { default: unknown }).default
    : C;
  if (typeof Comp === 'function') return Comp as React.ComponentType<{ size?: number; className?: string }>;
  if (Comp && typeof (Comp as { $$typeof?: unknown }).$$typeof !== 'undefined')
    return Comp as React.ComponentType<{ size?: number; className?: string }>;
  return null;
}
